// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Gz7o","label":"Radio_label__1CnMA","checkMark":"Radio_checkMark__2SlZj","disabled":"Radio_disabled__rnDXY"};